// System Settings Mutations

export const setSystemSettings = (state, payload) => {
  state.systemSettings = payload
}

export const oldSetSystemSettings = (state, payload) => {
  state.systemSettings = payload
}
